export const APP_INDEX_INTENTS = {
  FETCH_THEME_EMBED_STATUS: "fetch-theme-embed-status",
  FETCH_PLAN_UPGRADE_REQUIRED_STATUS: "fetch-plan-upgrade-required-status",
  FETCH_THEME_BLOCK_STATUS_SUMMARY: "fetch-theme-block-status-summary",
  FETCH_ALL_DISCOUNTS: "fetch-all-discounts",
  UPDATE_SESSION_TOKEN: "update-session-token",
  BULK_ACTIVATE: "bulk-activate",
  BULK_DEACTIVATE: "bulk-deactivate",
  BULK_DELETE: "bulk-delete",
} as const;

export const APP_INDEX_BULK_INTENTS = [
  APP_INDEX_INTENTS.BULK_ACTIVATE,
  APP_INDEX_INTENTS.BULK_DEACTIVATE,
  APP_INDEX_INTENTS.BULK_DELETE,
] as const;

export type AppIndexBulkIntent = (typeof APP_INDEX_BULK_INTENTS)[number];

export function isAppIndexBulkIntent(
  intent: unknown,
): intent is AppIndexBulkIntent {
  return (
    typeof intent === "string" &&
    (APP_INDEX_BULK_INTENTS as readonly string[]).includes(intent)
  );
}
